import { render, staticRenderFns } from "./NotifyOnObjectEvent.vue?vue&type=template&id=00fe93ac&scoped=true"
import script from "./NotifyOnObjectEvent.vue?vue&type=script&lang=js"
export * from "./NotifyOnObjectEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fe93ac",
  null
  
)

export default component.exports